/**
 * Публичные константы API и таймаутов для survey-client (аналогично passport-client api/urls).
 * URL строятся от `VITE_PASSPORT_API_BASE_URL` без завершающего слэша.
 *
 * @module constants
 */

/** Версия REST API Passport, используемая survey-client */
export const PASSPORT_API_VERSION = 'v1';

/** Относительный путь профиля (`GET /v1/profile`) */
export const PASSPORT_API_PROFILE_PATH = `${PASSPORT_API_VERSION}/profile`;

/** Относительный путь статуса регистрационного опроса */
export const PASSPORT_API_REGISTRATION_SURVEY_PATH = `${PASSPORT_API_VERSION}/registration-survey`;

/**
 * Таймаут HTTP для операций registration-survey (мс), по требованию сценария.
 */
export const REGISTRATION_SURVEY_REQUEST_TIMEOUT_MS = 30_000;

/**
 * Возвращает нормализованный базовый URL API Passport из Vite-окружения.
 *
 * @returns {string} базовый URL без завершающего `/`
 * @throws {Error} если переменная не задана или пустая
 */
export function getPassportApiBaseUrl(): string {
  const raw = import.meta.env.VITE_PASSPORT_API_BASE_URL;
  if (typeof raw !== 'string' || raw.trim() === '') {
    throw new Error('VITE_PASSPORT_API_BASE_URL must be a non-empty string');
  }
  return raw.replace(/\/$/, '');
}

/**
 * Полный URL `GET /v1/profile`.
 *
 * @returns {string}
 */
export function getPassportProfileUrl(): string {
  return `${getPassportApiBaseUrl()}/${PASSPORT_API_PROFILE_PATH}`;
}

/**
 * Полный URL `GET/POST /v1/registration-survey`.
 *
 * @returns {string}
 */
export function getPassportRegistrationSurveyUrl(): string {
  return `${getPassportApiBaseUrl()}/${PASSPORT_API_REGISTRATION_SURVEY_PATH}`;
}
